import { createAction } from '@reduxjs/toolkit';

/**
 * Signal actions: intents the UI dispatches for the saga (side effects, not
 * state transitions; the saga owns the resulting `load*` / `revoke*` reducers).
 */

/** Load the current user's sessions (dispatched on mount). */
export const loadRequested = createAction('securitySessions/loadRequested');

/** Revoke one session by id (sign out that device). */
export const revokeRequested = createAction<string>('securitySessions/revokeRequested');
